var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"action",attrs:{"aria-label":_vm.$t('buttons.schedule'),"title":_vm.$t('buttons.schedule'),"id":"schedule-button"},on:{"click":_vm.show}},[_c('i',{staticClass:"material-icons"},[_vm._v("alarm")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('buttons.schedule')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4d9a838","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/Schedule.vue
// module id = 370
// module chunks = 0